export default "__VITE_ASSET__4f7d9303__"